<template>
  <div id="editTimeModal" class="modal" @mousedown.self="closeEditModal">
    <div class="modal-dialog modal-dialog-sm">
      <div class="modal-title">{{$lang.messages.settings.unavailable.edit}}
        <span class="modal-close" @click="closeEditModal">
          <svg class="modal-close-icon"><use xlink:href="#icon-close"></use></svg>
        </span>
      </div>
      <div class="modal-content modal-content-narrow">
        <div class="text-md">{{ day }}</div>
        <div class="mb-2 timepicker-group flex">
          <div class="timepicker-group-item">
            <label for="timeFromMain" class="form-label">{{$lang.messages.settings.unavailable.from}}</label>
            <vue-timepicker input-class="form-control" v-model="timeRangeMainFrom" placeholder=" " format="h:mm A" id="timeFromMain" minute-interval="5" close-on-complete></vue-timepicker>
          </div>
          <div class="timepicker-group-item">
            <label for="timeToMain" class="form-label">{{$lang.messages.settings.unavailable.to}}</label>
            <vue-timepicker input-class="form-control" v-model="timeRangeMainTo" placeholder=" " format="h:mm A" id="timeToMain" minute-interval="5" close-on-complete></vue-timepicker>
          </div>
        </div>
        <div class="mb-2 timepicker-group flex form-error" v-if="isTimeError">{{$lang.messages.settings.unavailable.error}}</div>
        <div class="flex-between flex-v-center">
          <span class="text-md">{{$lang.messages.settings.unavailable.additional_time_range}}</span>
          <label class="switch">
            <input type="checkbox" :checked="additionalTime" @change="showAdditionalTimeBlock = !showAdditionalTimeBlock">
            <span class="slider"></span>
          </label>
        </div>
        <div v-if="showAdditionalTimeBlock" class="mb-2 timepicker-group flex">
          <div class="timepicker-group-item">
            <label for="timeFromAdd" class="form-label">{{$lang.messages.settings.unavailable.from}}</label>
            <vue-timepicker input-class="form-control" v-model="timeRangeAddFrom" placeholder=" " format="h:mm A" id="timeFromAdd" minute-interval="5" close-on-complete></vue-timepicker>
          </div>
          <div class="timepicker-group-item">
            <label for="timeToAdd" class="form-label">{{$lang.messages.settings.unavailable.to}}</label>
            <vue-timepicker input-class="form-control" v-model="timeRangeAddTo" placeholder=" " format="h:mm A" id="timeToAdd" minute-interval="5" close-on-complete></vue-timepicker>
          </div>
        </div>
        <div class="mb-2 timepicker-group flex form-error" v-if="isAdditionalTimeError">{{$lang.messages.settings.unavailable.error}}</div>
        <div class="mb-2 timepicker-group flex form-error" v-if="isAdditionalInMainError">{{$lang.messages.settings.unavailable.additional_main_error}}</div>
        <div class="flex-between flex-v-center mt-1">
          <span class="text-md">{{$lang.messages.settings.unavailable.block_day}}</span>
          <Checkbox :checkboxModel="{[availableTime[dayId].allDay]:blockAllDay}" @changecheckbox="blockAllDay = !blockAllDay; timeRangeMainFrom = ''; timeRangeMainTo = '';"/>
        </div>
      </div>
      <div class="modal-footer text-right">
        <button class="btn btn-main" @click="editUnavailableTime">{{$lang.messages.save}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from './Checkbox';
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

const timeVar = 'h:mm PM'

export default {
  name: 'EditTimeModal',
  props: ['dayId', 'time', 'day', 'additionalTime', 'blockDay', 'availableTime'],
  data: function () {
    return {
      isTimeError: false,
      isAdditionalTimeError: false,
      isAdditionalInMainError: false,
      timeRangeMainFrom: this.time && this.time[0].from ? this.time[0].from : timeVar,
      timeRangeMainTo: this.time && this.time[0].to ? this.time[0].to : timeVar,
      timeRangeAddFrom: this.time && this.time[1] ? this.time[1].from : timeVar,
      timeRangeAddTo: this.time && this.time[1] ? this.time[1].to : timeVar,
      showAdditionalTimeBlock: this.additionalTime,
      blockAllDay: this.blockDay
    }
  },
  methods: {
    closeEditModal() {
      this.$emit('closeedittimemodal');
    },
    editUnavailableTime() {
      this.isTimeError = false;
      this.isAdditionalTimeError = false;
      this.isAdditionalInMainError = false;
      const isSelectedMain = this.timeRangeMainFrom.length > 0 && this.timeRangeMainTo.length > 0;
      if (isSelectedMain && this.isFirstStringBigger(this.timeRangeMainFrom, this.timeRangeMainTo)) {
        this.isTimeError = true;
      }

      if (this.timeRangeAddFrom.length > 0 && this.timeRangeAddTo.length > 0) {
        if (this.isFirstStringBigger(this.timeRangeAddFrom, this.timeRangeAddTo)) {
          this.isAdditionalTimeError = true;
        }

        /**
         * @desc Checking if additional time not in main time
         */
        if (isSelectedMain && this.showAdditionalTimeBlock) {
          if (this.isFirstStringBigger(this.timeRangeAddFrom, this.timeRangeMainFrom) && this.isFirstStringBigger( this.timeRangeMainTo, this.timeRangeAddFrom))
          {
            this.isAdditionalInMainError = true;
          }
          if (this.isFirstStringBigger(this.timeRangeAddTo, this.timeRangeMainFrom) && this.isFirstStringBigger( this.timeRangeMainTo, this.timeRangeAddTo))
          {
            this.isAdditionalInMainError = true;
          }
          if (this.isFirstStringBigger(this.timeRangeMainFrom, this.timeRangeAddFrom) && this.isFirstStringBigger( this.timeRangeAddTo, this.timeRangeMainTo)) {
            this.isAdditionalInMainError = true;
          }
        }
      }

      if (!!this.timeRangeMainFrom !== !!this.timeRangeMainTo || !!this.timeRangeAddFrom !== !!this.timeRangeAddTo) {
        this.isTimeError = true;
      }

      if (this.isTimeError === true || this.isAdditionalTimeError === true || this.isAdditionalInMainError === true) {
        return false;
      }

      const unavailableTime = {
        id: this.dayId,
        allDay: this.blockAllDay,
        periods: null
      }

      if (!this.blockAllDay) {
        if (this.isTimeSelected(this.timeRangeMainFrom) && this.isTimeSelected(this.timeRangeMainTo)){
          const addPeriod = {
            id: 0,
            from: this.timeRangeMainFrom,
            to: this.timeRangeMainTo
          }

          unavailableTime['periods'] = [addPeriod];
        }

        if (this.isTimeSelected(this.timeRangeAddFrom) && this.isTimeSelected(this.timeRangeAddTo) && this.showAdditionalTimeBlock){
          const addPeriod = {
            id: 1,
            from: this.timeRangeAddFrom,
            to: this.timeRangeAddTo
          }
          if (unavailableTime.periods) {
            unavailableTime.periods.push(addPeriod)
          } else {
            unavailableTime['periods'] = [addPeriod];
          }
        }
      }

      this.$emit('editunavailabletime', unavailableTime);
    },

    isFirstStringBigger (str1, str2) {
      const firstDate = new Date('1/1/2013 ' + str1);
      const secondDate = new Date('1/1/2013 ' + str2);
      return firstDate >= secondDate;
    },

    isTimeSelected (time) {
      const splittedTime = time.split(/[: ]/)
      return Number.isInteger(parseInt(splittedTime[0])) || Number.isInteger(parseInt(splittedTime[1]))
    }
  },
  components: {
    Checkbox,
    VueTimepicker
  }
}

</script>
<style lang="scss">
.timepicker-group {
  margin-bottom: 24px;
  margin-top: 12px;

  &-item:first-child {
    margin-right: 24px;
    position: relative;

    &:after {
      content: "";
      display: block;
      width: 11px;
      height: 1px;
      position: absolute;
      bottom: 19px;
      right: -18px;
      background: #E2E2E2;
    }
  }
}

.vue__time-picker {
  width: 100%;

  input.form-control {
    width: 100%;
  }
}

.vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background: #7D6AED;
}

</style>
